import { Component } from "@angular/core";
import { AuthService } from "@ponder-core/auth/auth.service";
import { AdminUnauthorizedComponent } from "../admin-unauthorized.component";
import { UserPermissionType } from "@apiserver-rest/ponder-auth-client-base";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { RoleAndPermissions } from "@ponder-core/auth/role-permissions";

@Component({
    selector: "admin-alerts",
    imports: [LoadingComponent, AdminUnauthorizedComponent],
    templateUrl: "./admin-alerts.component.html"
})
export class AdminAlertsComponent {
    public isLoading: boolean = true;
    public canView: boolean = false;
    public canEdit: boolean = false;

    public constructor(private authService: AuthService) {
        
    }

    public ngOnInit(): void {
        this.authService.getRoleAndPermissions().then((roleAndPermissions: RoleAndPermissions | undefined) => {
            if (roleAndPermissions) {
                // todo: add backend stuff for alerts
                this.canView = false;
                this.canEdit = false;
            }

            this.isLoading = false;
        });
    }
}